class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape); 

    
    const toggle_dropdown_btn = this.querySelector('.toggle_dropdown_btn');
    if(toggle_dropdown_btn) {
      toggle_dropdown_btn.addEventListener('click',this.toggleDropdownList);
    }

   const sort_list_optionsArr = this.querySelectorAll('.sort-list-option');    
    if(sort_list_optionsArr.length) {
      facetForm.addEventListener('click',this.changeSortOption);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
   
    ;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
        if(document.querySelector('#ProductGridPaginationContainer')) {
        document.getElementById('ProductGridPaginationContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridPaginationContainer').innerHTML;
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    document.querySelectorAll('facet-range-group').forEach((group) => group.updateUnit?.());
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

    toggleDropdownList(e) {
    e.preventDefault();

    const listId = this.getAttribute('aria-controls');
    const dropdown_listEl = document.querySelector(`#${listId}`);
    if(dropdown_listEl) {
      this.classList.toggle('active');
      dropdown_listEl.classList.toggle('active');
    }
  }

    changeSortOption(e) {
    const el = e.target;
    if(el.classList.contains('sort-list-option')) {
         e.preventDefault();
      const sort_value = el.getAttribute('data-value');

      const SortByEl = this.querySelector('.facet-filters__sort');
      if(SortByEl) {
        SortByEl.value = sort_value;
        SortByEl.closest('form').submit();
      }
    }
  }
  

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);

// Sort pill buttons above the grid: same AJAX flow as filters, so active filters are kept
document.addEventListener('click', (event) => {
  const button = event.target.closest('.collection-sort-bar__btn');
  if (!button || button.classList.contains('is-active')) return;
  const bar = button.closest('.collection-sort-bar');
  const input = bar.querySelector('.collection-sort-bar__value');
  bar.querySelectorAll('.collection-sort-bar__btn').forEach((btn) => {
    const isActive = btn === button;
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-pressed', isActive);
  });
  input.value = button.dataset.value;
  input.dispatchEvent(new Event('input', { bubbles: true }));
});

// Range filters (Force / Stroke / Speed) are always open: no accordion toggle
document.addEventListener('click', (event) => {
  if (event.target.closest('.facets__summary--static')) event.preventDefault();
});

// Highlight a chip right away on click (the filter block that was changed is not re-rendered)
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.matches?.('.facet-checkbox input[type="checkbox"]')) return;
  input.closest('.facet-checkbox').classList.toggle('facet-checkbox--active', input.checked);
});
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

// Slider over the (visually hidden) checkboxes of a list filter: Force / Stroke / Speed.
// min / max / step and each value's number (data-range-number) are calculated in Liquid
// (snippets/facet-range-group.liquid, snippets/facet-value-number.liquid), so translated values work in every language.
class FacetRangeGroup extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.min = parseFloat(this.dataset.min);
    this.max = parseFloat(this.dataset.max);
    this.minInput = this.querySelector('.facet-range-group__input--min');
    this.maxInput = this.querySelector('.facet-range-group__input--max');
    this.minLabel = this.querySelector('.facet-range-group__value--min');
    this.maxLabel = this.querySelector('.facet-range-group__value--max');

    this.checkboxes = Array.from(this.closest('ul').querySelectorAll('input[type="checkbox"][data-range-number]'))
      .map((input) => ({ input, number: parseFloat(input.dataset.rangeNumber) }))
      .filter((item) => !Number.isNaN(item.number));
    this.unit = this.getUnit();

    // Real options the thumbs can stop on: available with the other filters (or already active), inside Liquid min / max
    this.options = [...new Set(this.checkboxes
      .filter(({ input }) => !input.disabled || input.checked)
      .map(({ number }) => number)
      .filter((number) => number >= this.min && number <= this.max))]
      .sort((a, b) => a - b);
    if (!this.options.length) this.options = [this.min, this.max];

    this.updateUnit();

    // Range filters have no accordion: if any script / Esc closes the <details>, open it again
    const details = this.closest('details');
    if (details) {
      details.open = true;
      // the <details> survives AJAX re-renders (only its innerHTML is replaced): add the listener once
      if (!details.dataset.rangeKeepOpen) {
        details.dataset.rangeKeepOpen = 'true';
        details.addEventListener('toggle', () => {
          if (!details.open) details.open = true;
        });
      }
    }

    [this.minInput, this.maxInput].forEach((input) => {
      // Slider moves must not reach the facet form's own "input" listener (it would submit on every step)
      input.addEventListener('input', (event) => {
        event.stopPropagation();
        this.snap(event.currentTarget);
        this.keepOrder(event.currentTarget);
        this.render();
      });
      input.addEventListener('change', () => this.applyRange());
      // Arrow keys move to the previous / next real option
      input.addEventListener('keydown', (event) => {
        const direction = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[event.key];
        if (!direction) return;
        event.preventDefault();
        const index = this.options.indexOf(this.getValue(input));
        input.value = this.options[Math.max(0, Math.min(this.options.length - 1, index + direction))];
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    this.render();
  }

  // Summary is replaced after each filter request (renderCounts), so the unit is set again from there too
  updateUnit() {
    const unitEl = this.closest('details')?.querySelector('.facets__summary-unit');
    if (!unitEl) return;
    // metric: unit name taken from the site converter ("lbs" -> "kg", '"/sec' -> "cm/sec", "Zoll" -> "cm")
    unitEl.textContent = FacetRangeGroup.isMetric() && this.unit
      ? FacetRangeGroup.convert(`1 ${this.unit}`).replace(/^[\d.,\s]+/, '')
      : this.unit;
  }

  static isMetric() {
    return Boolean(window.PAUnits?.isMetric());
  }

  static convert(text) {
    return window.PAUnits ? window.PAUnits.convertText(text, true) : text;
  }

  // Track stays linear (Liquid min / max), but a thumb only stops on a real option: "53.1 inch" -> "50 inch"
  nearestOption(value) {
    return this.options.reduce((best, option) => (Math.abs(option - value) < Math.abs(best - value) ? option : best));
  }

  snap(input) {
    input.value = this.nearestOption(parseFloat(input.value));
  }

  // Unit as written in the current language's labels ("lbs", "Pfund", "pulg/s"...): the most common one wins
  getUnit() {
    const counts = {};
    this.checkboxes.forEach(({ input }) => {
      // value, not the label: the unit converter rewrites labels to cm / kg
      const unit = input.value.replace(/^[^\d]*\d+(?:[.,\s]\d+)*/, '').split('-')[0].trim();
      if (unit) counts[unit] = (counts[unit] || 0) + 1;
    });
    return Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0] || '';
  }

  getValue(input) {
    return this.nearestOption(parseFloat(input.value));
  }

  format(number) {
    const separator = /^[\p{L}]/u.test(this.unit) ? ' ' : '';
    // Metric: filter values stay imperial, only the label is converted (same output as the rest of the page)
    if (FacetRangeGroup.isMetric() && this.unit) return FacetRangeGroup.convert(`${number}${separator}${this.unit}`);

    const formatted = number.toLocaleString(document.documentElement.lang || undefined, { maximumFractionDigits: 2 });
    return this.unit ? `${formatted}${separator}${this.unit}` : formatted;
  }

  keepOrder(changedInput) {
    if (parseFloat(this.minInput.value) <= parseFloat(this.maxInput.value)) return;
    if (changedInput === this.minInput) this.minInput.value = this.maxInput.value;
    else this.maxInput.value = this.minInput.value;
  }

  render() {
    const span = this.max - this.min || 1;
    const from = this.getValue(this.minInput);
    const to = this.getValue(this.maxInput);
    this.style.setProperty('--range-start', `${((from - this.min) / span) * 100}%`);
    this.style.setProperty('--range-end', `${((to - this.min) / span) * 100}%`);
    this.minLabel.textContent = this.format(from);
    this.maxLabel.textContent = this.format(to);
  }

  applyRange() {
    const from = this.getValue(this.minInput);
    const to = this.getValue(this.maxInput);
    const isFullRange = from <= this.min && to >= this.max;
    const inRange = (number) => number >= from && number <= to;

    let changed = null;
    this.checkboxes.forEach(({ input, number }) => {
      const shouldCheck = !isFullRange && inRange(number) && !input.disabled;
      if (input.checked !== shouldCheck) {
        input.checked = shouldCheck;
        changed = changed || input;
      }
    });

    // Thumbs jump to the real first / last selected option, so the slider matches the active pill
    const selected = this.checkboxes.filter(({ input }) => input.checked).map(({ number }) => number);
    if (selected.length) {
      this.minInput.value = Math.min(...selected);
      this.maxInput.value = Math.max(...selected);
    } else {
      this.minInput.value = this.min;
      this.maxInput.value = this.max;
    }
    this.render();

    // One event from a real checkbox -> facet form submits all checked values once
    if (changed) changed.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('facet-range-group', FacetRangeGroup);

// unit-toggle (inch / metric): custom.js fires this on load and on every switch
document.addEventListener('pa:units-change', () => {
  document.querySelectorAll('facet-range-group').forEach((group) => {
    if (!group.initialized || !group.minInput) return;
    group.updateUnit();
    group.render();
  });
});

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
   
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    const openedFilters = form.querySelectorAll('.js-filter[open]');
    if(form.classList.contains('facets')) {
      if(openedFilters.length) {
        openedFilters.forEach(function(details,index) {
          let facets__summary = details.querySelector('summary');
          if(facets__summary) {         
            facets__summary.click();
              facets__summary.dispatchEvent(new Event('click', { bubbles: true }));
  
          }
        });
      }
    }
      form.onActiveFilterClick(event);  
  }
}

customElements.define('facet-remove', FacetRemove);
